/**
 * @generated SignedSource<<62f5318fbe43e74d88c254d92e9f2599>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime'
export type postPage_preQuery$variables = {
  slug: string
}
export type postPage_preQuery$data = {
  readonly post: {
    readonly template_name: string
    readonly parent_post: {
      readonly slug: string
    } | null
    readonly status: string
    readonly redirect_to: string | null
    readonly shortcodes: ReadonlyArray<{
      readonly category: string
      readonly code: string
      readonly params: ReadonlyArray<{
        readonly key: string
        readonly value: string | null
      }>
    }>
  } | null
}
export type postPage_preQuery = {
  variables: postPage_preQuery$variables
  response: postPage_preQuery$data
}

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'slug'
      }
    ],
    v1 = [
      {
        alias: 'post',
        args: [
          {
            kind: 'Variable',
            name: 'slug',
            variableName: 'slug'
          }
        ],
        concreteType: 'Post',
        kind: 'LinkedField',
        name: 'getPost',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'template_name',
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'Post',
            kind: 'LinkedField',
            name: 'parent_post',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'slug',
                storageKey: null
              }
            ],
            storageKey: null
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'status',
            storageKey: null
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'redirect_to',
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'PostShortCode',
            kind: 'LinkedField',
            name: 'shortcodes',
            plural: true,
            selections: [
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'category',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'code',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                concreteType: 'PostShortCodeParam',
                kind: 'LinkedField',
                name: 'params',
                plural: true,
                selections: [
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'key',
                    storageKey: null
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'value',
                    storageKey: null
                  }
                ],
                storageKey: null
              }
            ],
            storageKey: null
          }
        ],
        storageKey: null
      }
    ]
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'postPage_preQuery',
      selections: v1 /*: any*/,
      type: 'Query',
      abstractKey: null
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'postPage_preQuery',
      selections: v1 /*: any*/
    },
    params: {
      cacheID: 'a766b90953e3d1079d999226a4964d66',
      id: null,
      metadata: {},
      name: 'postPage_preQuery',
      operationKind: 'query',
      text: 'query postPage_preQuery(\n  $slug: String!\n) {\n  post: getPost(slug: $slug) {\n    template_name\n    parent_post {\n      slug\n    }\n    status\n    redirect_to\n    shortcodes {\n      category\n      code\n      params {\n        key\n        value\n      }\n    }\n  }\n}\n'
    }
  }
})()

;(node as any).hash = '88cfde15579f0299c58e2f2b86b3b4eb'

export default node
